import sharedChatMessageIdMapping from "../../IdMappings/SharedChatMessageIdMapping.ts";
import {MessageNode} from "../../messageObject/MessageNode.ts";
import {getMessagesForChatId} from "../chatHistory/loadChat.ts";

export const shareClick = async (setDynamicStateObj: any, chatHistory: any[], chatId: string, user: any) => {
    Object.keys(sharedChatMessageIdMapping).forEach(key => delete sharedChatMessageIdMapping[key]);

    let chatName = "New Chat";
    const currentChat = chatHistory.filter((chat: any) => chat.id === chatId);
    if (currentChat.length === 1) chatName = currentChat[0].name;
    setDynamicStateObj({visiblePopup: 'share', shareChatName: chatName});

    const { messagesSequence, messages } = await getMessagesForChatId(user, chatId);
    if (!messagesSequence || !messages) {
        setDynamicStateObj({visiblePopup: null});
        return;
    }

    let foundRoot = false;
    for (let i = 0; i < messages.length; i++) {
        const { id, childNum, message, children, parent, metadata } = messages[i].message;
        sharedChatMessageIdMapping[id] = new MessageNode(id, childNum, message, children, parent, metadata);

        if (!parent) {
            foundRoot = true;
            setDynamicStateObj({shareMessages: sharedChatMessageIdMapping[id]});
        }
    }
    if (!foundRoot) return;

    setDynamicStateObj({shareMessagesSequence: messagesSequence});
}
